import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS.js";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import authService from "../../services/AuthService";

// import authService from "../../services/AuthService";
// import { buildCQLFilter } from "../../services/MapCore/MapCQLFilterService";
import LayerSettings from "./LayerSettings";
import { WMSLegend } from "../legends/WMSLegend";
import { findLayerById } from "../../services/MapCore/LayerGroupService";
import { buildCQLFilter } from "../../services/MapCore/MapCQLFilterService";
import { FeatureLayer } from "./Components/FeatureLayer";
import { DownloadGeojsonTool } from "../../components/CustomComponents/LayerTools/DownloadGeojsonTool/DownloadGeojsonTool";
import { LayerDescriptionTool } from "../../components/CustomComponents/LayerTools/LayerDescriptionTool/LayerDescriptionTool";
// import { findLayerById } from "../../services/MapCore/LayerGroupService";

class DefaultLayer extends LayerSettings {
  constructor(layer_data, layer_group_id) {
    super(layer_data);

    const {
      is_visible_by_default: visible,
      default_opacity: opacity,
      default_z_index: zIndex,
      name,
      desc: description,
      attribution_html,
      styles,
      uuid,
    } = layer_data;

    Object.assign(this, {
      visible,
      opacity,
      zIndex,
      name,
      description,
      attribution_html,
      layer_group_id,
      styles,
      uuid,
    });
    this.style_selected_geoserver_style_id =
      styles.find((style) => style.is_default)?.style.geoserver_style_id ||
      styles[0]?.style.geoserver_style_id;

    this.id = this.id.replace(layer_data.uuid, `default-${layer_data.uuid}`);
    this.legend = this.createLegend();
    this.filters = [
      {
        key: "layer_uuid",
        values: [layer_data.uuid],
        operation: "AND",
      },
    ];
    this.layer = this.createLayer();
  }

  getLayerTools(i18n) {
    const tools = [];
    if (this.layer_data?.desc[i18n.language]) {
      tools.push({ button: <LayerDescriptionTool key="desc" layer={this} /> });
    }
    if (this.layer_data?.is_downloadable) {
      tools.push({
        button: <DownloadGeojsonTool key="download" layer={this} />,
      });
    }
    return tools;
  }

  changeLegendStyle = (new_geoserver_style_id, map) => {
    this.style_selected_geoserver_style_id = new_geoserver_style_id;

    const new_style = this.styles.find(
      (style) => style.style.geoserver_style_id === new_geoserver_style_id
    ).style;

    const map_layer = findLayerById(map, this.id);
    map_layer.getSource().updateParams({ STYLES: new_geoserver_style_id });

    this.legend.changeLegendStyle(new_style);
  };

  createLegend = () => {
    const { geoserver_layer_id, styles } = this.layer_data;

    const new_legend = new WMSLegend({
      geoserver_layer_id,
      style: (
        styles?.find(
          (style) =>
            style.style.geoserver_style_id ===
            this.style_selected_geoserver_style_id
        ) || styles?.[0]
      )?.style,
    });

    return new_legend;
  };

  updateLayerStyle = () => {};

  createSource = () => {
    const {
      geoserver_url,
      geoserver_layer_id,
      geoserver_format,
      geoserver_srs,
      geoserver_version,
      is_tiles,
      layer_format,
    } = this.layer_data;

    const sourceParams = {
      url: geoserver_url + (layer_format === "WMS" ? "wms" : "ows"),
      params: {
        LAYERS: geoserver_layer_id,
        FORMAT: geoserver_format,
        SRS: geoserver_srs,
        VERSION: geoserver_version,
        CQL_FILTER: buildCQLFilter(this.filters),
        // STYLES: this.style.geoserver_style_id,
        STYLES: this.styles.find(
          (style) =>
            style.style.geoserver_style_id ===
            this.style_selected_geoserver_style_id
        ).style.geoserver_style_id,
      },
      projection: geoserver_srs,
      serverType: "geoserver",
    };

    if (is_tiles) {
      sourceParams.params.TILED = is_tiles;
      sourceParams.params.WIDTH = 1000;
      sourceParams.params.HEIGHT = 1000;
      return new TileWMS({
        ...sourceParams,
        tileLoadFunction: this.authLoadFunction,
      });
    } else {
      return new ImageWMS({
        ...sourceParams,
        imageLoadFunction: this.authLoadFunction,
      });
    }
  };

  createLayer = () => {
    const {
      geoserver_url,
      geoserver_layer_id,
      geoserver_format,
      geoserver_srs,
      geoserver_version,
      is_tiles,
      layer_format,
    } = this.layer_data;

    const sourceParams = {
      url: geoserver_url + (layer_format === "WMS" ? "wms" : "ows"),
      params: {
        LAYERS: geoserver_layer_id,
        FORMAT: geoserver_format,
        SRS: geoserver_srs,
        VERSION: geoserver_version,
        CQL_FILTER: buildCQLFilter(this.filters),
        STYLES: this.style_selected_geoserver_style_id,
      },
      projection: geoserver_srs,
      serverType: "geoserver",
    };

    if (is_tiles) {
      sourceParams.params.TILED = is_tiles;
      sourceParams.params.WIDTH = 1000;
      sourceParams.params.HEIGHT = 1000;

      return new TileLayer({
        id: this.id,
        source: new TileWMS({
          ...sourceParams,
          tileLoadFunction: this.authLoadFunction,
        }),
      });
    } else {
      return new ImageLayer({
        id: this.id,
        source: new ImageWMS({
          ...sourceParams,
          imageLoadFunction: this.authLoadFunction,
        }),
      });
    }
  };

  /**
   * Función de carga para añadir autenticación en peticiones de tiles.
   */
  authLoadFunction(element, src) {
    const token = authService.getToken();
    fetch(src, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const objectURL = URL.createObjectURL(blob);
        element.getImage().src = objectURL;
      })
      .catch((error) => console.error("Error cargando tile:", error));
  }

  getFeatureInfoOnClick = () => {
    // console.log("DefaultLayer getFeatureInfoOnClick");
  };

  getActionsOnRightClick = () => {
    // console.log("DefaultLayer getActionsOnRightClick");
    return [];
  };

  getChangeStyleComponent = () => {};

  getFeatureComponent(feature) {
    return <FeatureLayer feature={feature} key={this.id} />;
  }

  // getActionsOnRightClick = () => {};

  setVisible = (isVisible) => {
    this.visible = isVisible;
  };
}

export { DefaultLayer };
